export const stratosWhiteColor = "#FFFFFF";

// right side blur elipse
export const stratosGreenColor = "#43B78B";

// left side blur elipse
export const stratosPurpleColor = "#6A4EE1";

// body text - bt darker
export const stratosBodyTextColor = "#ebebeb";

export const stratosDeviderColor = "#444444";

// Landing page background color
export const stratosBackgroundColor = "#1B1B1B";

export const whiteOpacity30 = "#ffffff4d";
export const whiteOpacity10 = "#ffffff1a";
export const whiteOpacity5 = "#ffffff0d";

// leftovers to migrate
export const primaryColor = "#3C7EFF";
export const successColor = "#47BB98";
